import { createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vModelRadio as _vModelRadio, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-458e22cf")

_pushScopeId("data-v-458e22cf")
const _hoisted_1 = { class: "banner-upload" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "r-grid container" }, [
  /*#__PURE__*/_createVNode("h2", null, "Banner Upload")
], -1)
const _hoisted_3 = { class: "banner-upload-form-field-container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", {
  class: "banner-upload-form-checkbox-label",
  for: "banner-upload-form-checkbox__audit"
}, [
  /*#__PURE__*/_createVNode("strong", null, "I have completed the audit."),
  /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*"),
  /*#__PURE__*/_createVNode("div", null, " In order to proceed with the banner upload, you must complete an audit. Use reports such as Negative Leave Balance, Pending Requests, Conflict Reports to conduct an audit for your department. ")
], -1)
const _hoisted_5 = { class: "banner-upload-form-field-container wrap" }
const _hoisted_6 = { class: "banner-upload-form-field-container wrap" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "banner-upload-form-radio-heading banner-upload-form-field-label" }, [
  /*#__PURE__*/_createVNode("strong", null, "Do you want to validate or run a final upload?"),
  /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*"),
  /*#__PURE__*/_createVNode("div", { class: "banner-upload-form-field-label" }, " Validate Only option will validate your data and mock a Banner upload for your review. Final upload will actually upload leave data to Banner ")
], -1)
const _hoisted_8 = { class: "banner-upload-form-radio" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  class: "banner-upload-form-radio-label",
  for: "banner-upload-form-radio__validate"
}, " Validate Only ", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  class: "banner-upload-form-radio-label",
  for: "banner-upload-form-radio__final"
}, " Final Upload ", -1)
const _hoisted_11 = { class: "banner-upload-form-submit" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createVNode("h3", { class: "banner-upload-form-heading" }, "Summary", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("strong", null, "Employee Groups included in the upload: ")
], -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = {
  key: 0,
  class: "banner-upload-form-summary-exceptions"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Exception List: (Exceptions will be excluded from this batch process) ")
const _hoisted_20 = /*#__PURE__*/_createVNode("p", null, "After submitting, you will receive a confirmation via email", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = {
  key: 2,
  class: "red"
}
const _hoisted_25 = {
  key: 1,
  class: "banner-upload-form-confirm-checkbox"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("label", {
  class: "banner-upload-form-confirm-checkbox-label",
  for: "confirm-checkbox"
}, " I understand ", -1)
const _hoisted_27 = { class: "button-group" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_List = _resolveComponent("List")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GroupContainer = _resolveComponent("GroupContainer")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_GroupContainer, { heading: "Setup Options" }, {
      default: _withId(() => [
        (_ctx.state == 'checklist')
          ? (_openBlock(), _createBlock("form", {
              key: 0,
              class: "banner-upload-form",
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
              "aria-label": "Checklist Form"
            }, [
              _createVNode("div", _hoisted_3, [
                _withDirectives(_createVNode("input", {
                  id: "banner-upload-form-checkbox__audit",
                  class: "banner-upload-form-checkbox gotime-checkbox",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.checklist.audit = $event)),
                  type: "checkbox",
                  "aria-label": "I completed the Audit",
                  "aria-required": "true",
                  role: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.checklist.audit]
                ]),
                _hoisted_4
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_List, {
                  list: _ctx.exceptions.uin,
                  header: "UIN Exception(s)",
                  description: "Add UINs one at a time to the exception list below.\n              Exceptions will be excluded from this batch process.\n              All exceptions should be processed manually by your department.",
                  onListChanged: _ctx.uinListChanged,
                  listTypeName: "UIN"
                }, null, 8, ["list", "onListChanged"])
              ]),
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", null, [
                    _withDirectives(_createVNode("input", {
                      id: "banner-upload-form-radio__validate",
                      class: "banner-upload-form-radio gotime-checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.checklist.validateOnly = $event)),
                      type: "radio",
                      "aria-label": "Validate only",
                      value: true
                    }, null, 512), [
                      [_vModelRadio, _ctx.checklist.validateOnly]
                    ]),
                    _hoisted_9
                  ]),
                  _createVNode("div", null, [
                    _withDirectives(_createVNode("input", {
                      id: "banner-upload-form-radio__final",
                      class: "banner-upload-form-radio gotime-checkbox",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.checklist.validateOnly = $event)),
                      type: "radio",
                      "aria-label": "Final Upload",
                      value: false
                    }, null, 512), [
                      [_vModelRadio, _ctx.checklist.validateOnly]
                    ]),
                    _hoisted_10
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_Button, {
                  text: "Review",
                  type: "submit",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state='summary')),
                  disabled: _ctx.isCheckListBtnDisabled
                }, null, 8, ["disabled"])
              ])
            ], 32))
          : _createCommentVNode("", true),
        (_ctx.state == 'summary')
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("div", null, [
                _hoisted_14,
                (_ctx.filter.employeeType == 'all')
                  ? (_openBlock(), _createBlock("span", _hoisted_15, "All"))
                  : _createCommentVNode("", true),
                (_ctx.filter.employeeType == 'ap_faculty')
                  ? (_openBlock(), _createBlock("span", _hoisted_16, " Academic Employees (AP and Faculty) "))
                  : _createCommentVNode("", true),
                (_ctx.filter.employeeType == 'cs_exempt')
                  ? (_openBlock(), _createBlock("span", _hoisted_17, "Civil Service Employees (CS Exempt)"))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.exceptions.uin.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode("ul", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.exceptions.uin, (user) => {
                        return (_openBlock(), _createBlock("li", {
                          key: user.uin
                        }, _toDisplayString(user.name) + " (" + _toDisplayString(user.uin) + ") ", 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", null, [
                _hoisted_20,
                (!_ctx.checklist.validateOnly)
                  ? (_openBlock(), _createBlock("span", _hoisted_21, " This is the final banner upload. This uploads the leaves data to Banner "))
                  : (_openBlock(), _createBlock("span", _hoisted_22, " This Validate Only option will validate your data and mock a Banner upload for your review. This option does not upload data to Banner ")),
                _hoisted_23,
                (!_ctx.checklist.validateOnly)
                  ? (_openBlock(), _createBlock("span", _hoisted_24, " Once uploaded, it can't be reverted back "))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.checklist.validateOnly)
                ? (_openBlock(), _createBlock("div", _hoisted_25, [
                    _withDirectives(_createVNode("input", {
                      class: "gotime-checkbox",
                      type: "checkbox",
                      id: "confirm-checkbox",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.summary.confirm = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.summary.confirm]
                    ]),
                    _hoisted_26
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_27, [
                _createVNode(_component_Button, {
                  text: "Back to Setup Options",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.state = 'checklist'))
                }),
                _createVNode(_component_Button, {
                  text: _ctx.summaryBtnText,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitRequest())),
                  disabled: _ctx.isSummaryBtnDisabled
                }, null, 8, ["text", "disabled"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})